import React from 'react';
import { Container, Grid } from 'basis';
import styled from '@emotion/styled';

export const VerticalContainer = styled.div`
  padding: ${props =>
    props.padding || props.noPadding
      ? '0'
      : `${props?.theme?.space?.[5] ?? '20px'} 0px ${props?.theme?.space?.[5] ?? '20px'} 0px`};
  & + & {
    padding-top: 0;
  }
`;

const widerSizing = {
  colSpan: 'all',
  'colSpan-lg': '2-9',
};

export function LayoutContent({ children, rowsGap, testId, padding, noPadding, ...props }) {
  return (
    <VerticalContainer padding={padding} noPadding={noPadding} data-testid={testId || 'layout-content'}>
      <Container hasBreakpointWidth {...props}>
        <Grid preset="page" debug={false}>
          <Grid.Item {...widerSizing}>
            <Grid rowsGap={rowsGap || '8'}>{children}</Grid>
          </Grid.Item>
        </Grid>
      </Container>
    </VerticalContainer>
  );
}
